import React from "react";
import { Box, Container, useTheme } from "@mui/material";

type SectionBg = "default" | "paper" | "navy" | "gradient";

interface SectionProps {
  bg?: SectionBg;
  py?: { xs: number; md: number } | number;
  id?: string;
  maxWidth?: "sm" | "md" | "lg" | "xl" | false;
  children: React.ReactNode;
}

/** Full-bleed background band with an inner Container. */
const Section: React.FC<SectionProps> = ({
  bg = "default",
  py = { xs: 6, md: 9 },
  id,
  maxWidth = "lg",
  children,
}) => {
  const theme = useTheme();

  const bgStyles = {
    default: { bgcolor: "background.default" },
    paper: { bgcolor: "background.paper" },
    navy: { bgcolor: "primary.dark", color: "primary.contrastText" },
    gradient: {
      background: theme.custom.gradients.hero,
      color: "primary.contrastText",
    },
  }[bg];

  return (
    <Box component="section" id={id} sx={{ py, ...bgStyles }}>
      <Container maxWidth={maxWidth} sx={{ px: { xs: 2, sm: 3, md: 4 } }}>
        {children}
      </Container>
    </Box>
  );
};

export default Section;
